import { useEffect, useRef } from 'react';

export function useInterval(
	callback: () => void,
	delay: number,
	deps?: Array<any>,
) {
	// Creating a ref
	const savedCallback: any = useRef();

	// To remember the latest callback .
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// combining the setInterval and
	//clearInterval methods based on delay.
	let dependencies = [delay];
	if (deps) {
		dependencies = dependencies.concat(deps);
	}
	useEffect(() => {
		savedCallback.current();
		function func() {
			savedCallback.current();
		}
		if (delay !== null) {
			const id = setInterval(func, delay);
			return () => clearInterval(id);
		}
	}, dependencies);
}
